import React, { createContext, FC, MouseEvent, useContext, useMemo } from 'react';
import { ConnectionPortType } from '@glueapp/graph-types';

export const PortEventsContext = createContext<{
    onOutPortMouseDown: (event: MouseEvent, portName: string, portType?: ConnectionPortType) => void;
    onInPortMouseUp: (event: MouseEvent, portName: string, portType?: ConnectionPortType) => void;
    onInPortMouseDown: (event: MouseEvent, portName: string, portType?: ConnectionPortType) => void;
}>({
    onOutPortMouseDown: () => {},
    onInPortMouseUp: () => {},
    onInPortMouseDown: () => {},
});

interface PortEventsContextProviderProps {
    onOutPortMouseDown: (event: MouseEvent, portName: string, portType?: ConnectionPortType) => void;
    onInPortMouseUp: (event: MouseEvent, portName: string, portType?: ConnectionPortType) => void;
    onInPortMouseDown: (event: MouseEvent, portName: string, portType?: ConnectionPortType) => void;
    children: React.ReactNode;
}

export const PortEventsContextProvider: FC<PortEventsContextProviderProps> = props => {
    const value = useMemo(
        () => ({
            onOutPortMouseDown: props.onOutPortMouseDown,
            onInPortMouseUp: props.onInPortMouseUp,
            onInPortMouseDown: props.onInPortMouseDown,
        }),
        [props.onOutPortMouseDown, props.onInPortMouseUp, props.onInPortMouseDown],
    );
    return <PortEventsContext.Provider value={value}>{props.children}</PortEventsContext.Provider>;
};

export function usePortEvents() {
    return useContext(PortEventsContext);
}
